import { useState, useEffect } from "react";
import styles from "./addmyaddress.module.css";
import { useForm } from "react-hook-form";
import { Button, Input, HeadingTitle } from "../../../../../components/shared";
import {
  useAddUserAddressMutation,
  useStateListQuery,
  useUpdateUserAddressMutation,
} from "../../../../../queries/useUserAddress";
import toast from "react-hot-toast";
const AddMyAddress = ({ onClose, mode = "add", initialData = null, addressId = null }) => {
  const [countryId] = useState(101); // India ID
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country_id: countryId,
    },
  });
  const { data: states = [] } = useStateListQuery(countryId);
  const { mutate: addAddress, isPending } = useAddUserAddressMutation();
  const { mutate: updateAddress } = useUpdateUserAddressMutation();
  useEffect(() => {
    if (mode === "edit" && initialData) {
      Object.keys(initialData).forEach((key) => {
        if (initialData[key]) setValue(key, initialData[key]);
      });
    }
  }, [mode, initialData]);
  const onSubmit = (data) => {
    if (mode === "edit") {
      updateAddress(
        { id: addressId, payload: data },
        {
          onSuccess: () => {
            toast.success("Your address has been updated successfully...");
            onClose();
          },
          onError: (err) => {
            toast.error(
              err?.response?.data?.message ||
                "Could not update the address. Please try again."
            );
          },
        }
      );
    } else {
      addAddress(data, {
        onSuccess: () => {
          toast.success("Your address has been added successfully...");
          reset();
          onClose();
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message || "Could not save address");
        },
      });
    }
  };
  return (
    <form className={styles.addAddressContainer} onSubmit={handleSubmit(onSubmit)}>
      <HeadingTitle
        text={mode === "add" ? "Add Address" : "Edit Address"}
        style={styles.addAddressTitle}
      />
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Full Name :</label>
        <Input
          placeholder="Enter your name"
          name="name"
          register={register}
          validation={{ required: "Name is required" }}
          error={errors.name?.message}
        />
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Email :</label>
        <Input
          placeholder="Enter email"
          name="email"
          register={register}
          validation={{
            required: "Email required",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Enter valid email",
            },
          }}
          error={errors.email?.message}
        />
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Mobile Number :</label>
        <Input
          placeholder="xxxxxxxxxx"
          name="phone"
          register={register}
          validation={{
            required: "Mobile number is required",
            pattern: {
              value: /^[6-9]\d{9}$/,
              message: "Enter a valid 10-digit mobile number",
            },
            maxLength: { value: 10, message: "Mobile number must be 10 digits" },
            minLength: { value: 10, message: "Mobile number must be 10 digits" },
          }}
          error={errors?.phone?.message}
        />
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Country :</label>
        <Input
          placeholder="India"
          name="country_name"
          register={register}
          value="India"
          disabled
        />
      </div>
      <Input
        placeholder="101"
        name="country_id"
        register={register}
        value={countryId}
        readOnly
        type="hidden"
      />
      <Input
        placeholder="State Id"
        name="state_id"
        register={register}
        readOnly
        type="hidden"
      />
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>State :</label>
        <div className={styles.addAddressInputWrapper}>
          <select
            className={styles.addAddressSelect}
            onChange={(e) => setValue("state_id", e.target.value)}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>City :</label>
        <Input
          placeholder="Enter city"
          name="city"
          register={register}
          validation={{ required: "City is required" }}
          error={errors.city?.message}
        />
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Zip Code :</label>
        <Input
          placeholder="Enter pincode"
          name="zip"
          register={register}
          validation={{
            required: "Pincode is required",
            pattern: { value: /^[0-9]{6}$/, message: "Enter valid 6-digit pincode" },
          }}
          error={errors.zip?.message}
        />
      </div>
      <div className={styles.addAddressRow}>
        <label className={styles.addAddressLabel}>Full Address :</label>
        <Input
          placeholder="Enter complete address"
          name="address"
          register={register}
          validation={{ required: "Address is required" }}
          error={errors.address?.message}
        />
      </div>
      <div className={styles.addAddressBtnWrapper}>
        <Button
          title={mode === "add" ? "Add Address" : "Update Address"}
          type="submit"
          style={styles.addAddressUpdateBtn}
          disabled={isPending}
        />
        <Button
          title="Cancel"
          type="button"
          style={styles.addAddressCancelBtn}
          onHandler={onClose}
        />
      </div>
    </form>
  );
};
export default AddMyAddress;